
import { useState } from 'react';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

interface FlowerLanguage {
  id: number;
  name: string;
  englishName: string;
  meanings: string[];
  season: string;
  color: string;
  description: string;
  image: string;
  category: string;
  meaningCategory: string; // 新しく追加：花言葉の分野
}

const flowerLanguages: FlowerLanguage[] = [
  // 蘭類
  {
    id: 1,
    name: '胡蝶蘭',
    englishName: 'Phalaenopsis',
    meanings: ['幸福が飛んでくる', '純粋な愛', '上品', '美しい淑女'],
    season: '通年',
    color: 'white',
    description: '胡蝶蘭は蝶が舞うような美しい花姿から、幸福が飛んでくるという素敵な花言葉を持ちます。お祝いの贈り物として人気が高く、上品で洗練された印象を与えます。',
    image: 'https://public.readdy.ai/ai/img_res/fd0da1c483a59c6c34eef012dc3db310.jpg',
    category: 'orchid',
    meaningCategory: 'love'
  },
  {
    id: 2,
    name: 'カトレア',
    englishName: 'Cattleya',
    meanings: ['優美な貴婦人', '成熟した大人の魅力', '魔力', 'あなたは美しい'],
    season: '通年',
    color: 'purple',
    description: 'ランの女王と呼ばれるカトレア。その華麗で気品ある姿から、優美な貴婦人という花言葉を持ちます。コサージュとしても人気の高い花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20cattleya%20orchid%20flowers%20in%20full%20bloom%2C%20regal%20and%20elegant%20appearance%20with%20ruffled%20petals%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20luxury%20orchid%20arrangement%20style&width=400&height=300&seq=cattleya-1&orientation=landscape',
    category: 'orchid',
    meaningCategory: 'beauty'
  },
  {
    id: 3,
    name: 'デンドロビウム',
    englishName: 'Dendrobium',
    meanings: ['わがままな美人', '天性の華を持つ', '思いやり', '純粋'],
    season: '春',
    color: 'pink',
    description: 'デンドロビウムは多様な色と形を持つ蘭の仲間。わがままな美人という花言葉は、その美しさゆえの気まぐれさを表現しています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20dendrobium%20orchid%20flowers%20in%20clusters%2C%20delicate%20petals%20with%20natural%20grace%2C%20soft%20spring%20lighting%2C%20detailed%20botanical%20photography%2C%20elegant%20orchid%20arrangement&width=400&height=300&seq=dendrobium-1&orientation=landscape',
    category: 'orchid',
    meaningCategory: 'beauty'
  },
  {
    id: 4,
    name: 'オンシジウム',
    englishName: 'Oncidium',
    meanings: ['可憐', '一緒に踊って', '遊び心', '美しい瞳'],
    season: '秋',
    color: 'yellow',
    description: 'ダンシングレディとも呼ばれるオンシジウム。小さな黄色い花が踊っているように見えることから、一緒に踊ってという愛らしい花言葉を持ちます。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yellow%20oncidium%20orchid%20flowers%20dancing%20in%20clusters%2C%20small%20golden%20blooms%20resembling%20dancing%20ladies%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20cheerful%20orchid%20arrangement&width=400&height=300&seq=oncidium-1&orientation=landscape',
    category: 'orchid',
    meaningCategory: 'joy'
  },
  {
    id: 5,
    name: 'シンビジウム',
    englishName: 'Cymbidium',
    meanings: ['飾らない心', '素朴', '高貴な美人', '誠実な愛情'],
    season: '冬',
    color: 'green',
    description: 'シンビジウムは比較的育てやすい蘭として人気。飾らない心という花言葉は、その素朴で親しみやすい美しさを表現しています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20green%20cymbidium%20orchid%20flowers%20in%20elegant%20arrangement%2C%20sophisticated%20and%20understated%20beauty%2C%20soft%20winter%20lighting%2C%20detailed%20botanical%20photography%2C%20refined%20orchid%20display&width=400&height=300&seq=cymbidium-1&orientation=landscape',
    category: 'orchid',
    meaningCategory: 'sincerity'
  },

  // 春の花
  {
    id: 6,
    name: '桜',
    englishName: 'Cherry Blossom',
    meanings: ['精神美', '優美な女性', '純潔', '心の美しさ'],
    season: '春',
    color: 'pink',
    description: '日本の象徴的な花である桜は、その美しい花姿から精神美や優美な女性という花言葉を持ちます。春の訪れを告げる花として、多くの人に愛され続けています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20cherry%20blossom%20flowers%20in%20full%20bloom%2C%20delicate%20pink%20petals%2C%20spring%20season%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20aesthetic%2C%20serene%20background&width=400&height=300&seq=sakura-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'beauty'
  },
  {
    id: 7,
    name: 'チューリップ',
    englishName: 'Tulip',
    meanings: ['思いやり', '博愛', '正直', '名声'],
    season: '春',
    color: 'red',
    description: 'チューリップは色によって異なる花言葉を持ちます。赤いチューリップは愛の告白を、黄色は望みのない恋を、白は失われた愛を表現します。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20tulip%20flowers%20in%20spring%20garden%2C%20vibrant%20cup-shaped%20blooms%2C%20fresh%20spring%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20colorful%20tulip%20field&width=400&height=300&seq=tulip-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'love'
  },
  {
    id: 8,
    name: 'スイートピー',
    englishName: 'Sweet Pea',
    meanings: ['門出', '別れの言葉', '優しい思い出', '感謝'],
    season: '春',
    color: 'purple',
    description: 'スイートピーは卒業式などでよく使われる花で、門出や別れの言葉という花言葉を持ちます。甘い香りと美しい色合いで、特別な日を彩ります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20sweet%20pea%20flowers%20with%20delicate%20fragrance%2C%20elegant%20butterfly-like%20petals%2C%20spring%20season%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20garden%20setting%20background&width=400&height=300&seq=sweetpea-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'farewell'
  },
  {
    id: 9,
    name: '忘れな草',
    englishName: 'Forget-me-not',
    meanings: ['真実の愛', '私を忘れないで', '思い出', '誠の愛'],
    season: '春',
    color: 'blue',
    description: '忘れな草は小さな青い花が印象的で、真実の愛や私を忘れないでという深い愛情を表す花言葉を持ちます。恋人同士の贈り物として人気があります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20blue%20forget-me-not%20flowers%2C%20tiny%20delicate%20blooms%20with%20yellow%20centers%2C%20romantic%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20green%20meadow%20background%2C%20spring%20garden%20setting&width=400&height=300&seq=forgetmenot-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'love'
  },
  {
    id: 10,
    name: 'スズラン',
    englishName: 'Lily of the Valley',
    meanings: ['再び幸せが訪れる', '純粋', '純潔', '謙遜'],
    season: '春',
    color: 'white',
    description: 'スズランは小さな白い鈴のような花を咲かせます。再び幸せが訪れるという希望に満ちた花言葉を持ち、フランスでは幸運のお守りとされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20lily%20of%20the%20valley%20flowers%2C%20tiny%20bell-shaped%20blooms%20hanging%20gracefully%2C%20pure%20and%20delicate%20appearance%2C%20soft%20spring%20lighting%2C%20detailed%20botanical%20photography%2C%20forest%20floor%20setting&width=400&height=300&seq=lily-valley-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'hope'
  },
  {
    id: 11,
    name: 'ライラック',
    englishName: 'Lilac',
    meanings: ['思い出', '友情', '謙虚', '青春の喜び'],
    season: '春',
    color: 'purple',
    description: 'ライラックは香り高い花として知られ、思い出や友情という温かい花言葉を持ちます。紫色の花房が美しく、庭木としても人気があります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20lilac%20flowers%20in%20full%20bloom%2C%20fragrant%20flower%20clusters%2C%20spring%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20romantic%20garden%20setting&width=400&height=300&seq=lilac-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'friendship'
  },
  {
    id: 12,
    name: 'パンジー',
    englishName: 'Pansy',
    meanings: ['もの思い', '私を思って', '心の平和', '思慮深い'],
    season: '春',
    color: 'purple',
    description: 'パンジーは人の顔のような模様が特徴的で、もの思いという花言葉を持ちます。フランス語の「パンセ（思考）」が名前の由来です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20pansy%20flowers%20with%20face-like%20patterns%2C%20velvety%20petals%20with%20distinctive%20markings%2C%20spring%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20colorful%20flower%20bed&width=400&height=300&seq=pansy-1&orientation=landscape',
    category: 'spring',
    meaningCategory: 'contemplation'
  },

  // 夏の花
  {
    id: 13,
    name: 'ひまわり',
    englishName: 'Sunflower',
    meanings: ['憧れ', '愛慕', '崇拝', '情熱'],
    season: '夏',
    color: 'yellow',
    description: 'ひまわりは太陽に向かって咲く姿から、憧れや愛慕という情熱的な花言葉を持ちます。夏の代表的な花として、明るく元気な印象を与えます。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20yellow%20sunflowers%20in%20full%20bloom%2C%20large%20vibrant%20petals%20facing%20the%20sun%2C%20summer%20season%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20blue%20sky%20background%2C%20cheerful%20flower%20field&width=400&height=300&seq=sunflower-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'passion'
  },
  {
    id: 14,
    name: 'カスミソウ',
    englishName: 'Baby\'s Breath',
    meanings: ['清らかな心', '無邪気', '親切', '幸福'],
    season: '夏',
    color: 'white',
    description: 'カスミソウは小さな白い花が霞のように咲く姿から、清らかな心や無邪気という純粋な花言葉を持ちます。ブーケの脇役として人気が高い花です。',
    image: 'https://readdy.ai/api/search-image?query=Delicate%20white%20baby%20breath%20flowers%2C%20tiny%20blooms%20creating%20cloud-like%20appearance%2C%20soft%20ethereal%20atmosphere%2C%20gentle%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20minimalist%20clean%20background%2C%20pure%20and%20innocent%20style&width=400&height=300&seq=babysbreath-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'purity'
  },
  {
    id: 15,
    name: 'ガーベラ',
    englishName: 'Gerbera',
    meanings: ['希望', '常に前進', '神秘', '崇高美'],
    season: '通年',
    color: 'orange',
    description: 'ガーベラは明るく元気な印象の花で、希望や常に前進という前向きな花言葉を持ちます。カラフルな色合いで、お祝いの花束によく使われます。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20orange%20gerbera%20daisy%20flowers%20in%20full%20bloom%2C%20bright%20cheerful%20petals%20with%20bold%20colors%2C%20energetic%20atmosphere%2C%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20colorful%20garden%20background&width=400&height=300&seq=gerbera-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'hope'
  },
  {
    id: 16,
    name: 'ペチュニア',
    englishName: 'Petunia',
    meanings: ['あなたと一緒なら心がやわらぐ', '心のやすらぎ', '決して諦めない'],
    season: '夏',
    color: 'pink',
    description: 'ペチュニアは夏の暑さに強く、長期間咲き続けます。あなたと一緒なら心がやわらぐという優しい花言葉を持ち、ガーデニングで人気の花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20petunia%20flowers%20in%20summer%20garden%2C%20trumpet-shaped%20blooms%20with%20soft%20petals%2C%20warm%20summer%20atmosphere%2C%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20abundant%20flowering%20display&width=400&height=300&seq=petunia-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'comfort'
  },
  {
    id: 17,
    name: 'マリーゴールド',
    englishName: 'Marigold',
    meanings: ['嫉妬', '絶望', '悲しみ', '変わらぬ愛'],
    season: '夏',
    color: 'orange',
    description: 'マリーゴールドは鮮やかなオレンジ色が特徴的ですが、意外にも嫉妬や絶望といったネガティブな花言葉を持ちます。しかし、変わらぬ愛という美しい意味もあります。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20orange%20marigold%20flowers%20in%20full%20bloom%2C%20ruffled%20petals%20with%20rich%20golden%20color%2C%20summer%20garden%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20abundant%20flower%20display&width=400&height=300&seq=marigold-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'complex'
  },
  {
    id: 18,
    name: 'ジニア',
    englishName: 'Zinnia',
    meanings: ['不在の友を思う', '注意を怠るな', '幸福'],
    season: '夏',
    color: 'red',
    description: 'ジニアは百日草とも呼ばれ、長期間咲き続けることで知られています。不在の友を思うという花言葉は、その持続性から生まれました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20zinnia%20flowers%20in%20summer%20garden%2C%20full%20double%20blooms%20with%20layered%20petals%2C%20vibrant%20summer%20atmosphere%2C%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20colorful%20flower%20bed&width=400&height=300&seq=zinnia-1&orientation=landscape',
    category: 'summer',
    meaningCategory: 'friendship'
  },

  // 秋の花
  {
    id: 19,
    name: 'コスモス',
    englishName: 'Cosmos',
    meanings: ['乙女の真心', '謙虚', '調和', '美麗'],
    season: '秋',
    color: 'pink',
    description: 'コスモスは秋の風に揺れる可憐な姿から、乙女の真心や謙虚という美しい花言葉を持ちます。秋の代表的な花として、多くの人に愛されています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20cosmos%20flowers%20swaying%20in%20autumn%20breeze%2C%20delicate%20petals%20with%20graceful%20form%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20gentle%20autumn%20atmosphere%2C%20field%20of%20flowers%20background&width=400&height=300&seq=cosmos-1&orientation=landscape',
    category: 'autumn',
    meaningCategory: 'sincerity'
  },
  {
    id: 20,
    name: 'キク',
    englishName: 'Chrysanthemum',
    meanings: ['高貴', '高潔', '高尚', '真の愛'],
    season: '秋',
    color: 'yellow',
    description: '菊は日本の国花として親しまれ、高貴や高潔という気品ある花言葉を持ちます。皇室の紋章としても使われ、格式高い花として扱われています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yellow%20chrysanthemum%20flowers%20in%20full%20bloom%2C%20elegant%20layered%20petals%20with%20perfect%20symmetry%2C%20autumn%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20flower&width=400&height=300&seq=chrysanthemum-1&orientation=landscape',
    category: 'autumn',
    meaningCategory: 'nobility'
  },
  {
    id: 21,
    name: 'ダリア',
    englishName: 'Dahlia',
    meanings: ['華麗', '優雅', '気品', '移り気'],
    season: '秋',
    color: 'red',
    description: 'ダリアは大輪の華やかな花で、華麗や優雅という花言葉を持ちます。多様な色と形があり、秋の庭を美しく彩る代表的な花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20dahlia%20flowers%20in%20full%20bloom%2C%20large%20elaborate%20petals%20with%20perfect%20form%2C%20autumn%20garden%20atmosphere%2C%20rich%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20elegant%20flower%20display&width=400&height=300&seq=dahlia-1&orientation=landscape',
    category: 'autumn',
    meaningCategory: 'beauty'
  },
  {
    id: 22,
    name: 'ケイトウ',
    englishName: 'Cockscomb',
    meanings: ['おしゃれ', '気取り', '風変わり', '色あせぬ恋'],
    season: '秋',
    color: 'red',
    description: 'ケイトウは鶏のトサカのような独特な形が特徴的で、おしゃれや気取りという花言葉を持ちます。その個性的な姿が印象的な秋の花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20cockscomb%20flowers%20with%20unique%20feathery%20texture%2C%20distinctive%20plume-like%20blooms%2C%20autumn%20garden%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20unusual%20flower%20form&width=400&height=300&seq=cockscomb-1&orientation=landscape',
    category: 'autumn',
    meaningCategory: 'uniqueness'
  },

  // 冬の花
  {
    id: 23,
    name: 'シクラメン',
    englishName: 'Cyclamen',
    meanings: ['遠慮', '気後れ', '内気', '恥じらい'],
    season: '冬',
    color: 'pink',
    description: 'シクラメンは下向きに咲く花の姿から、控えめで内気な花言葉を持ちます。冬の代表的な花として親しまれ、その美しさは多くの人に愛されています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20cyclamen%20flowers%20blooming%20in%20winter%2C%20delicate%20petals%20with%20elegant%20form%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20green%20foliage%20background%2C%20seasonal%20flower%20arrangement&width=400&height=300&seq=cyclamen-1&orientation=landscape',
    category: 'winter',
    meaningCategory: 'modesty'
  },
  {
    id: 24,
    name: 'ポインセチア',
    englishName: 'Poinsettia',
    meanings: ['祝福', '幸運を祈る', '私の心は燃えている', '清純'],
    season: '冬',
    color: 'red',
    description: 'ポインセチアはクリスマスの花として有名で、祝福や幸運を祈るという温かい花言葉を持ちます。赤い苞葉が美しく、冬の室内を彩ります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20poinsettia%20flowers%20with%20vibrant%20bracts%2C%20Christmas%20season%20atmosphere%2C%20festive%20winter%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20holiday%20flower%20arrangement&width=400&height=300&seq=poinsettia-1&orientation=landscape',
    category: 'winter',
    meaningCategory: 'celebration'
  },
  {
    id: 25,
    name: 'カメリア',
    englishName: 'Camellia',
    meanings: ['完全なる美しさ', '誇り', '理想の愛', '謙遜'],
    season: '冬',
    color: 'red',
    description: '椿（カメリア）は冬の寒さに負けず美しく咲く花で、完全なる美しさという花言葉を持ちます。日本の冬を代表する花として古くから愛されています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20camellia%20flowers%20blooming%20in%20winter%2C%20perfect%20waxy%20petals%20with%20glossy%20leaves%2C%20elegant%20winter%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20flower&width=400&height=300&seq=camellia-1&orientation=landscape',
    category: 'winter',
    meaningCategory: 'beauty'
  },

  // 定番の花
  {
    id: 26,
    name: '薔薇',
    englishName: 'Rose',
    meanings: ['愛', '美', '情熱', '尊敬'],
    season: '通年',
    color: 'red',
    description: '花の女王と呼ばれる薔薇は、色によって異なる花言葉を持ちます。赤い薔薇は情熱的な愛を、白い薔薇は純潔を、ピンクの薔薇は感謝を表現します。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20roses%20in%20full%20bloom%2C%20velvety%20petals%20with%20elegant%20form%2C%20romantic%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20green%20foliage%20background%2C%20classic%20flower%20arrangement&width=400&height=300&seq=rose-1&orientation=landscape',
    category: 'classic',
    meaningCategory: 'love'
  },
  {
    id: 27,
    name: 'カーネーション',
    englishName: 'Carnation',
    meanings: ['無垢で深い愛', '母への愛', '感謝', '尊敬'],
    season: '通年',
    color: 'red',
    description: 'カーネーションは母の日の花として有名で、母への愛や感謝という温かい花言葉を持ちます。色によって異なる意味を持ち、贈り物として人気です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20carnation%20flowers%20with%20ruffled%20petals%2C%20elegant%20and%20classic%20appearance%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20soft%20focus%20background%2C%20traditional%20flower%20arrangement%20style&width=400&height=300&seq=carnation-1&orientation=landscape',
    category: 'classic',
    meaningCategory: 'gratitude'
  },
  {
    id: 28,
    name: 'ユリ',
    englishName: 'Lily',
    meanings: ['純粋', '無垢', '威厳', '高貴'],
    season: '夏',
    color: 'white',
    description: 'ユリは純粋や無垢という清らかな花言葉を持ちます。白いユリは特に純潔の象徴とされ、結婚式などの神聖な場面でよく使われます。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20lily%20flowers%20in%20full%20bloom%2C%20elegant%20trumpet-shaped%20petals%20with%20golden%20stamens%2C%20pure%20and%20graceful%20appearance%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20serene%20garden%20setting&width=400&height=300&seq=lily-1&orientation=landscape',
    category: 'classic',
    meaningCategory: 'purity'
  },

  // エアプランツ・多肉植物
  {
    id: 29,
    name: 'チランジア',
    englishName: 'Tillandsia',
    meanings: ['不屈', '自由', '独立', '強い意志'],
    season: '通年',
    color: 'green',
    description: 'チランジアは土がなくても育つエアプランツとして知られ、その強い生命力から不屈や自由という花言葉を持ちます。現代的なインテリアとしても人気です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20air%20plants%20with%20silver-green%20foliage%2C%20unique%20sculptural%20forms%2C%20modern%20botanical%20arrangement%2C%20soft%20natural%20lighting%2C%20minimalist%20clean%20background%2C%20contemporary%20plant%20design&width=400&height=300&seq=tillandsia-1&orientation=landscape',
    category: 'airplant',
    meaningCategory: 'strength'
  },
  {
    id: 30,
    name: 'サボテン',
    englishName: 'Cactus',
    meanings: ['燃える心', '偉大', '暖かい心', '枯れない愛'],
    season: '通年',
    color: 'green',
    description: 'サボテンは厳しい環境でも生き抜く強さから、燃える心や枯れない愛という情熱的な花言葉を持ちます。その生命力の強さが愛の永続性を象徴しています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20flowering%20cactus%20with%20vibrant%20blooms%2C%20desert%20plant%20with%20colorful%20flowers%2C%20succulent%20garden%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20unique%20desert%20flora&width=400&height=300&seq=cactus-1&orientation=landscape',
    category: 'succulent',
    meaningCategory: 'passion'
  },

  // 香りの花
  {
    id: 31,
    name: 'ジャスミン',
    englishName: 'Jasmine',
    meanings: ['愛想のよさ', '優美', '愛らしさ', '官能的'],
    season: '夏',
    color: 'white',
    description: 'ジャスミンは甘い香りで知られ、愛想のよさや優美という花言葉を持ちます。その魅惑的な香りは香水の原料としても使われています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20jasmine%20flowers%20with%20intense%20fragrance%2C%20small%20star-shaped%20blooms%20on%20climbing%20vine%2C%20romantic%20garden%20atmosphere%2C%20soft%20evening%20lighting%2C%20detailed%20botanical%20photography%2C%20aromatic%20flower%20display&width=400&height=300&seq=jasmine-1&orientation=landscape',
    category: 'fragrant',
    meaningCategory: 'charm'
  },
  {
    id: 32,
    name: 'ラベンダー',
    englishName: 'Lavender',
    meanings: ['沈黙', '私に答えて', '期待', '疑惑'],
    season: '夏',
    color: 'purple',
    description: 'ラベンダーはリラックス効果のある香りで人気があり、沈黙や私に答えてという控えめな花言葉を持ちます。ハーブとしても広く利用されています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20lavender%20flowers%20in%20field%2C%20aromatic%20herb%20with%20spike-like%20blooms%2C%20peaceful%20countryside%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20fragrant%20garden%20landscape&width=400&height=300&seq=lavender-1&orientation=landscape',
    category: 'fragrant',
    meaningCategory: 'mystery'
  },

  // 野草・山野草
  {
    id: 33,
    name: 'タンポポ',
    englishName: 'Dandelion',
    meanings: ['愛の神託', '神託', '真心の愛', '別れ'],
    season: '春',
    color: 'yellow',
    description: 'タンポポは身近な野草として親しまれ、愛の神託という神秘的な花言葉を持ちます。綿毛を飛ばして願いを込める習慣もあります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yellow%20dandelion%20flowers%20in%20spring%20meadow%2C%20bright%20golden%20blooms%20with%20serrated%20leaves%2C%20natural%20grassland%20setting%2C%20soft%20spring%20lighting%2C%20detailed%20botanical%20photography%2C%20common%20wildflower&width=400&height=300&seq=dandelion-1&orientation=landscape',
    category: 'wildflower',
    meaningCategory: 'divine'
  },
  {
    id: 34,
    name: 'クローバー',
    englishName: 'Clover',
    meanings: ['私を思って', '幸運', '約束', '復讐'],
    season: '春',
    color: 'white',
    description: 'クローバーは四つ葉が幸運の象徴として有名で、私を思ってや幸運という花言葉を持ちます。三つ葉は信仰・希望・愛を表すとされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20clover%20flowers%20in%20green%20meadow%2C%20small%20round%20blooms%20with%20three-leaf%20pattern%2C%20natural%20grassland%20setting%2C%20soft%20spring%20lighting%2C%20detailed%20botanical%20photography%2C%20lucky%20shamrock%20plant&width=400&height=300&seq=clover-1&orientation=landscape',
    category: 'wildflower',
    meaningCategory: 'luck'
  },

  // 球根植物
  {
    id: 35,
    name: 'ヒヤシンス',
    englishName: 'Hyacinth',
    meanings: ['スポーツ', '遊び', '悲しみを超えた愛', '初恋のひたむきさ'],
    season: '春',
    color: 'blue',
    description: 'ヒヤシンスは香り高い春の球根植物で、スポーツや遊びという活動的な花言葉を持ちます。ギリシャ神話に由来する美しい花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20blue%20hyacinth%20flowers%20in%20spring%20garden%2C%20dense%20spikes%20of%20fragrant%20blooms%2C%20vibrant%20spring%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20bulb%20flower%20display&width=400&height=300&seq=hyacinth-1&orientation=landscape',
    category: 'bulb',
    meaningCategory: 'joy'
  },
  {
    id: 36,
    name: 'クロッカス',
    englishName: 'Crocus',
    meanings: ['青春の喜び', '切望', '歓喜', '信頼'],
    season: '春',
    color: 'purple',
    description: 'クロッカスは雪解けとともに咲く早春の花で、青春の喜びという希望に満ちた花言葉を持ちます。春の訪れを告げる可憐な花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20crocus%20flowers%20emerging%20from%20snow%2C%20early%20spring%20blooms%20with%20cup-shaped%20petals%2C%20hopeful%20spring%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20first%20spring%20flowers&width=400&height=300&seq=crocus-1&orientation=landscape',
    category: 'bulb',
    meaningCategory: 'joy'
  },

  // 水生植物
  {
    id: 37,
    name: 'ハス',
    englishName: 'Lotus',
    meanings: ['清らかな心', '神聖', '離れゆく愛', '雄弁'],
    season: '夏',
    color: 'pink',
    description: 'ハスは泥の中から美しい花を咲かせることから、清らかな心や神聖という花言葉を持ちます。仏教では悟りの象徴とされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20lotus%20flowers%20blooming%20in%20pond%2C%20sacred%20water%20lily%20with%20large%20petals%2C%20serene%20water%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20spiritual%20flower%20setting&width=400&height=300&seq=lotus-1&orientation=landscape',
    category: 'aquatic',
    meaningCategory: 'spirituality'
  },
  {
    id: 38,
    name: 'スイレン',
    englishName: 'Water Lily',
    meanings: ['清純な心', '信頼', '信仰', '純粋'],
    season: '夏',
    color: 'white',
    description: 'スイレンは水面に浮かぶ美しい花で、清純な心や信頼という清らかな花言葉を持ちます。モネの絵画でも有名な水辺の花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20water%20lily%20flowers%20floating%20on%20pond%20surface%2C%20elegant%20blooms%20with%20lily%20pads%2C%20peaceful%20water%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20aquatic%20flower%20display&width=400&height=300&seq=waterlily-1&orientation=landscape',
    category: 'aquatic',
    meaningCategory: 'purity'
  },

  // 熱帯の花
  {
    id: 39,
    name: 'ハイビスカス',
    englishName: 'Hibiscus',
    meanings: ['繊細な美', '新しい恋', '勇敢', '華やか'],
    season: '夏',
    color: 'red',
    description: 'ハイビスカスは南国の代表的な花で、繊細な美や新しい恋という情熱的な花言葉を持ちます。一日花として知られ、その儚い美しさが魅力です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20hibiscus%20flowers%20in%20tropical%20setting%2C%20large%20showy%20blooms%20with%20prominent%20stamens%2C%20exotic%20paradise%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20tropical%20flower%20display&width=400&height=300&seq=hibiscus-1&orientation=landscape',
    category: 'tropical',
    meaningCategory: 'love'
  },
  {
    id: 40,
    name: 'プルメリア',
    englishName: 'Plumeria',
    meanings: ['気品', '恵まれた人', '日だまり', '内気な乙女'],
    season: '夏',
    color: 'white',
    description: 'プルメリアはハワイのレイに使われる香り高い花で、気品や恵まれた人という上品な花言葉を持ちます。その甘い香りは南国の象徴です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20plumeria%20flowers%20with%20yellow%20centers%2C%20fragrant%20tropical%20blooms%2C%20Hawaiian%20paradise%20atmosphere%2C%20warm%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20exotic%20flower%20arrangement&width=400&height=300&seq=plumeria-1&orientation=landscape',
    category: 'tropical',
    meaningCategory: 'elegance'
  },

  // 和の花
  {
    id: 41,
    name: 'アジサイ',
    englishName: 'Hydrangea',
    meanings: ['移り気', '浮気', '辛抱強い愛情', '家族団らん'],
    season: '夏',
    color: 'blue',
    description: 'アジサイは梅雨の時期に咲く代表的な花で、色が変化することから移り気という花言葉を持ちます。しかし、辛抱強い愛情という美しい意味もあります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20blue%20hydrangea%20flowers%20in%20rainy%20season%2C%20large%20clustered%20blooms%20with%20changing%20colors%2C%20Japanese%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20traditional%20summer%20flower&width=400&height=300&seq=hydrangea-1&orientation=landscape',
    category: 'japanese',
    meaningCategory: 'complex'
  },
  {
    id: 42,
    name: 'ツバキ',
    englishName: 'Camellia Japonica',
    meanings: ['完全なる美しさ', '誇り', '理想の愛', '謙遜'],
    season: '冬',
    color: 'red',
    description: '椿は日本の代表的な花で、完全なる美しさという花言葉を持ちます。冬の寒さに負けず咲く姿は、日本人の心に深く根ざしています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20camellia%20japonica%20flowers%20in%20winter%20garden%2C%20perfect%20waxy%20petals%20with%20glossy%20dark%20leaves%2C%20traditional%20Japanese%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20classic%20Japanese%20flower&width=400&height=300&seq=camellia-japonica-1&orientation=landscape',
    category: 'japanese',
    meaningCategory: 'beauty'
  },

  // ハーブ
  {
    id: 43,
    name: 'ローズマリー',
    englishName: 'Rosemary',
    meanings: ['追憶', '思い出', '記憶', '変わらぬ愛'],
    season: '通年',
    color: 'blue',
    description: 'ローズマリーは記憶力を高めるハーブとして知られ、追憶や思い出という花言葉を持ちます。その香りは集中力を高める効果があるとされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20blue%20rosemary%20flowers%20on%20aromatic%20herb%20plant%2C%20small%20needle-like%20leaves%20with%20tiny%20blooms%2C%20Mediterranean%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20culinary%20herb%20display&width=400&height=300&seq=rosemary-1&orientation=landscape',
    category: 'herb',
    meaningCategory: 'memory'
  },
  {
    id: 44,
    name: 'セージ',
    englishName: 'Sage',
    meanings: ['尊敬', '知恵', '良い家庭', '家族愛'],
    season: '夏',
    color: 'purple',
    description: 'セージは古くから薬草として使われ、尊敬や知恵という花言葉を持ちます。その名前はラテン語の「救う」に由来し、癒しの象徴とされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20sage%20flowers%20in%20herb%20garden%2C%20aromatic%20plant%20with%20spike-like%20blooms%2C%20Mediterranean%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20medicinal%20herb%20display&width=400&height=300&seq=sage-1&orientation=landscape',
    category: 'herb',
    meaningCategory: 'wisdom'
  },

  // 実のなる花
  {
    id: 45,
    name: 'イチゴ',
    englishName: 'Strawberry',
    meanings: ['尊重と愛情', '幸福な家庭', '先見の明', '完全なる善'],
    season: '春',
    color: 'white',
    description: 'イチゴの白い花は尊重と愛情という温かい花言葉を持ちます。その後に実る甘い果実は、幸福な家庭の象徴とされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20strawberry%20flowers%20with%20yellow%20centers%2C%20small%20five-petaled%20blooms%20on%20fruit%20plant%2C%20spring%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20edible%20flower%20display&width=400&height=300&seq=strawberry-1&orientation=landscape',
    category: 'fruit',
    meaningCategory: 'family'
  },

  // 珍しい花
  {
    id: 46,
    name: 'パッションフラワー',
    englishName: 'Passion Flower',
    meanings: ['聖なる愛', '信仰', '宗教的熱情', '受難'],
    season: '夏',
    color: 'purple',
    description: 'パッションフラワーは複雑で美しい花の構造から、聖なる愛や信仰という神聖な花言葉を持ちます。キリストの受難を表すとされる神秘的な花です。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20passion%20flower%20with%20intricate%20corona%2C%20complex%20exotic%20bloom%20structure%2C%20mystical%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20unique%20tropical%20vine%20flower&width=400&height=300&seq=passionflower-1&orientation=landscape',
    category: 'exotic',
    meaningCategory: 'spirituality'
  },

  // 小さな花
  {
    id: 47,
    name: 'アリッサム',
    englishName: 'Sweet Alyssum',
    meanings: ['優美', '美しさに優る価値', '奥ゆかしさ'],
    season: '春',
    color: 'white',
    description: 'アリッサムは小さな白い花が集まって咲く可憐な花で、優美や奥ゆかしさという上品な花言葉を持ちます。グランドカバーとしても人気があります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20sweet%20alyssum%20flowers%20in%20carpet-like%20display%2C%20tiny%20clustered%20blooms%20with%20honey%20fragrance%2C%20spring%20garden%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20delicate%20ground%20cover%20flower&width=400&height=300&seq=alyssum-1&orientation=landscape',
    category: 'small',
    meaningCategory: 'elegance'
  },

  // 高山植物
  {
    id: 48,
    name: 'エーデルワイス',
    englishName: 'Edelweiss',
    meanings: ['大切な思い出', '勇気', '尊い記憶', '高貴'],
    season: '夏',
    color: 'white',
    description: 'エーデルワイスはアルプスの高山に咲く貴重な花で、大切な思い出や勇気という花言葉を持ちます。その希少性から愛の証として贈られることもあります。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20edelweiss%20flowers%20in%20alpine%20setting%2C%20woolly%20star-shaped%20blooms%20on%20mountain%20peaks%2C%20high%20altitude%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20rare%20mountain%20flower&width=400&height=300&seq=edelweiss-1&orientation=landscape',
    category: 'alpine',
    meaningCategory: 'courage'
  },

  // 夜咲く花
  {
    id: 49,
    name: 'ゲッカビジン',
    englishName: 'Queen of the Night',
    meanings: ['はかない美', 'はかない恋', '一夜の恋', '艶やかな美人'],
    season: '夏',
    color: 'white',
    description: '月下美人は一夜だけ咲く神秘的な花で、はかない美やはかない恋という儚い花言葉を持ちます。その一夜限りの美しさは多くの人を魅了します。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20queen%20of%20the%20night%20cactus%20flower%20blooming%20at%20night%2C%20large%20fragrant%20nocturnal%20bloom%2C%20mysterious%20moonlight%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20rare%20night-blooming%20flower&width=400&height=300&seq=queenofnight-1&orientation=landscape',
    category: 'nocturnal',
    meaningCategory: 'ephemeral'
  },

  // 毒のある花
  {
    id: 50,
    name: 'スズラン',
    englishName: 'Lily of the Valley',
    meanings: ['再び幸せが訪れる', '純粋', '純潔', '謙遜'],
    season: '春',
    color: 'white',
    description: 'スズランは可憐な見た目とは裏腹に毒を持つ花ですが、再び幸せが訪れるという希望的な花言葉を持ちます。フランスでは幸運のお守りとされています。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20lily%20of%20the%20valley%20flowers%2C%20tiny%20bell-shaped%20blooms%20hanging%20gracefully%2C%20pure%20and%20delicate%20appearance%2C%20soft%20spring%20lighting%2C%20detailed%20botanical%20photography%2C%20forest%20floor%20setting&width=400&height=300&seq=lily-valley-2&orientation=landscape',
    category: 'spring',
    meaningCategory: 'hope'
  }
];

const categories = [
  { id: 'all', name: 'すべて', icon: 'ri-flower-line' },
  { id: 'orchid', name: '蘭類', icon: 'ri-leaf-line' },
  { id: 'spring', name: '春の花', icon: 'ri-sun-line' },
  { id: 'summer', name: '夏の花', icon: 'ri-sun-fill' },
  { id: 'autumn', name: '秋の花', icon: 'ri-leaf-fill' },
  { id: 'winter', name: '冬の花', icon: 'ri-snowflake-line' },
  { id: 'classic', name: '定番の花', icon: 'ri-heart-line' },
  { id: 'airplant', name: 'エアプランツ', icon: 'ri-seedling-line' },
  { id: 'succulent', name: '多肉植物', icon: 'ri-plant-line' },
  { id: 'fragrant', name: '香りの花', icon: 'ri-emotion-happy-line' },
  { id: 'wildflower', name: '野草', icon: 'ri-grass-line' },
  { id: 'bulb', name: '球根植物', icon: 'ri-drop-line' },
  { id: 'aquatic', name: '水生植物', icon: 'ri-water-percent-line' },
  { id: 'tropical', name: '熱帯の花', icon: 'ri-fire-line' },
  { id: 'japanese', name: '和の花', icon: 'ri-ancient-gate-line' },
  { id: 'herb', name: 'ハーブ', icon: 'ri-flask-line' },
  { id: 'fruit', name: '実のなる花', icon: 'ri-apple-line' },
  { id: 'exotic', name: '珍しい花', icon: 'ri-star-line' },
  { id: 'small', name: '小さな花', icon: 'ri-heart-2-line' },
  { id: 'alpine', name: '高山植物', icon: 'ri-mountain-line' },
  { id: 'nocturnal', name: '夜咲く花', icon: 'ri-moon-line' }
];

// 花言葉の分野別カテゴリー
const meaningCategories = [
  { id: 'all', name: 'すべて', icon: 'ri-heart-line' },
  { id: 'love', name: '愛・恋愛', icon: 'ri-heart-fill' },
  { id: 'beauty', name: '美・優雅', icon: 'ri-star-line' },
  { id: 'friendship', name: '友情・絆', icon: 'ri-team-line' },
  { id: 'hope', name: '希望・幸福', icon: 'ri-sun-line' },
  { id: 'purity', name: '純粋・清らか', icon: 'ri-drop-line' },
  { id: 'sincerity', name: '誠実・真心', icon: 'ri-shield-check-line' },
  { id: 'gratitude', name: '感謝・尊敬', icon: 'ri-hand-heart-line' },
  { id: 'strength', name: '強さ・勇気', icon: 'ri-sword-line' },
  { id: 'wisdom', name: '知恵・学問', icon: 'ri-book-line' },
  { id: 'spirituality', name: '神聖・信仰', icon: 'ri-ancient-pavilion-line' },
  { id: 'joy', name: '喜び・楽しさ', icon: 'ri-emotion-happy-line' },
  { id: 'passion', name: '情熱・熱意', icon: 'ri-fire-line' },
  { id: 'modesty', name: '謙虚・控えめ', icon: 'ri-leaf-line' },
  { id: 'nobility', name: '高貴・気品', icon: 'ri-crown-line' },
  { id: 'memory', name: '思い出・記憶', icon: 'ri-time-line' },
  { id: 'family', name: '家族・絆', icon: 'ri-home-heart-line' },
  { id: 'celebration', name: 'お祝い・祝福', icon: 'ri-gift-line' },
  { id: 'comfort', name: '癒し・安らぎ', icon: 'ri-heart-2-line' },
  { id: 'mystery', name: '神秘・謎', icon: 'ri-question-line' },
  { id: 'farewell', name: '別れ・旅立ち', icon: 'ri-flight-takeoff-line' },
  { id: 'luck', name: '幸運・運命', icon: 'ri-magic-line' },
  { id: 'contemplation', name: '思索・瞑想', icon: 'ri-mind-map' },
  { id: 'charm', name: '魅力・愛嬌', icon: 'ri-sparkling-line' },
  { id: 'elegance', name: '上品・洗練', icon: 'ri-vip-crown-line' },
  { id: 'uniqueness', name: '個性・独特', icon: 'ri-fingerprint-line' },
  { id: 'courage', name: '勇敢・冒険', icon: 'ri-rocket-line' },
  { id: 'ephemeral', name: '儚さ・一時', icon: 'ri-hourglass-line' },
  { id: 'divine', name: '神託・運命', icon: 'ri-crystal-ball-line' },
  { id: 'complex', name: '複雑・多面', icon: 'ri-puzzle-line' }
];

export default function FlowerLanguage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedMeaningCategory, setSelectedMeaningCategory] = useState('all');
  const [selectedColor, setSelectedColor] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFlower, setSelectedFlower] = useState<FlowerLanguage | null>(null);

  const filteredFlowers = flowerLanguages.filter(flower => {
    const matchesCategory = selectedCategory === 'all' || flower.category === selectedCategory;
    const matchesMeaningCategory = selectedMeaningCategory === 'all' || flower.meaningCategory === selectedMeaningCategory;
    const matchesColor = selectedColor === 'all' || flower.color === selectedColor;
    const matchesSearch = flower.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.englishName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.meanings.some(meaning => meaning.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesCategory && matchesMeaningCategory && matchesColor && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20flower%20language%20garden%20with%20various%20colorful%20flowers%20including%20roses%2C%20orchids%2C%20and%20seasonal%20blooms%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20illustration%2C%20poetic%20and%20elegant%20setting&width=1920&height=600&seq=flower-language-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            花言葉の世界
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            花に込められた美しいメッセージを探索し、心に響く花言葉を発見しましょう。
            <br />
            それぞれの花が持つ特別な意味と物語をお楽しみください。
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gradient-to-br from-pink-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative max-w-md mx-auto">
                <input
                  type="text"
                  placeholder="花の名前や花言葉で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-pink-500 text-sm"
                />
                <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
              </div>
            </div>

            {/* Meaning Category Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">花言葉の分野</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {meaningCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedMeaningCategory(category.id)}
                    className={`px-3 py-2 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedMeaningCategory === category.id
                        ? 'bg-purple-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-purple-100'
                    }`}
                  >
                    <i className={`${category.icon} mr-1`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Category Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">花のカテゴリー</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-3 py-2 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedCategory === category.id
                        ? 'bg-pink-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-pink-100'
                    }`}
                  >
                    <i className={`${category.icon} mr-1`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Flowers Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {filteredFlowers.length}種類の花言葉
            </h2>
            <p className="text-gray-600">美しい花言葉の世界をお楽しみください</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredFlowers.map((flower) => (
              <div
                key={flower.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer group"
                onClick={() => setSelectedFlower(flower)}
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={flower.image}
                    alt={flower.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium text-gray-700">
                    {flower.season}
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-bold text-gray-800">{flower.name}</h3>
                    <span className="text-xs text-gray-500">{flower.englishName}</span>
                  </div>
                  <div className="flex flex-wrap gap-1 mb-3">
                    {flower.meanings.slice(0, 2).map((meaning, index) => (
                      <span
                        key={index}
                        className="bg-pink-100 text-pink-800 px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {meaning}
                      </span>
                    ))}
                    {flower.meanings.length > 2 && (
                      <span className="text-gray-500 text-xs">+{flower.meanings.length - 2}</span>
                    )}
                  </div>
                  <p className="text-gray-600 text-xs line-clamp-2">{flower.description}</p>
                </div>
              </div>
            ))}
          </div>

          {filteredFlowers.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">該当する花が見つかりません</h3>
              <p className="text-gray-500">検索条件を変更してお試しください</p>
            </div>
          )}
        </div>
      </section>

      {/* Flower Detail Modal */}
      {selectedFlower && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <img
                src={selectedFlower.image}
                alt={selectedFlower.name}
                className="w-full h-64 object-cover object-top"
              />
              <button
                onClick={() => setSelectedFlower(null)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm w-10 h-10 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedFlower.name}</h2>
                  <p className="text-gray-500 text-lg">{selectedFlower.englishName}</p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500 mb-1">開花時期</div>
                  <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    {selectedFlower.season}
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">花言葉</h3>
                <div className="flex flex-wrap gap-3">
                  {selectedFlower.meanings.map((meaning, index) => (
                    <span
                      key={index}
                      className="bg-gradient-to-r from-pink-100 to-purple-100 text-pink-800 px-4 py-2 rounded-full font-medium"
                    >
                      {meaning}
                    </span>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">説明</h3>
                <p className="text-gray-600 leading-relaxed">{selectedFlower.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tips Section */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">花言葉の豆知識</h2>
            <p className="text-gray-600">花言葉をより深く理解するためのヒント</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-heart-line text-2xl text-pink-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">色による違い</h3>
              <p className="text-gray-600">同じ花でも色によって花言葉が異なることがあります。贈り物の際は色の意味も考慮しましょう。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-global-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">文化による違い</h3>
              <p className="text-gray-600">花言葉は国や文化によって異なる場合があります。日本独特の花言葉も多く存在します。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-book-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">歴史と由来</h3>
              <p className="text-gray-600">花言葉には古い伝説や歴史的背景があります。その由来を知ることで、より深く花を理解できます。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
